import React, { useState } from 'react';
import { CarbUnit } from '../types';
import { FPUExplanationModal } from './FPUExplanationModal';
import './AdvancedOptions.css';

interface AdvancedOptionsProps {
  carbUnit: CarbUnit;
  onUnitChange: (unit: CarbUnit) => void;
  customPortionGrams: number | undefined;
  onCustomPortionChange: (grams: number | undefined) => void;
  language: 'en' | 'de';
  showFPU: boolean;
  onShowFPUChange: (show: boolean) => void;
}

export const AdvancedOptions: React.FC<AdvancedOptionsProps> = ({
  carbUnit,
  onUnitChange,
  customPortionGrams,
  onCustomPortionChange,
  language,
  showFPU,
  onShowFPUChange
}) => {
  const isGerman = language === 'de';
  const [showFPUModal, setShowFPUModal] = useState(false);

  return (
    <div className="advanced-options">
      <div className="options-content">
        <div className="option-group">
          <label className="option-label">
            {isGerman ? 'Einheit:' : 'Unit:'}
          </label>
          <div className="custom-select-wrapper">
            <select 
              value={carbUnit} 
              onChange={(e) => onUnitChange(e.target.value as CarbUnit)}
              className="unit-selector"
            >
              {isGerman ? (
                <>
                  <option value="gKH">gKH - Gramm Kohlenhydrate</option>
                  <option value="BE">BE - Broteinheit</option>
                  <option value="KE">KE - Kohlenhydrateinheit</option>
                </>
              ) : (
                <>
                  <option value="g">g - gram carbs</option>
                  <option value="BU">BU - bread units</option>
                </>
              )}
            </select>
            <div className="select-display">{carbUnit}</div>
          </div>
        </div>
        
        <div className="option-group">
          <label className="option-label">
            {isGerman ? 'Portion:' : 'Serving:'}
          </label>
          <div className="custom-portion-input">
            <input
              type="number"
              value={customPortionGrams && customPortionGrams > 0 ? customPortionGrams : ''}
              onChange={(e) => {
                const value = Number(e.target.value);
                onCustomPortionChange(value > 0 ? value : undefined);
              }}
              placeholder="100"
              min="1"
              max="9999"
              className="portion-input"
            />
            <span className="input-unit">g</span>
          </div>
        </div>
        
        <div className="option-group">
          <label className="option-label checkbox-label">
            <input
              type="checkbox"
              checked={showFPU}
              onChange={(e) => onShowFPUChange(e.target.checked)}
              className="fpu-checkbox"
            />
            <span className="checkbox-text">
              {isGerman ? 'FPE' : 'FPU'}
            </span>
            <button
              type="button"
              className="fpu-info-button"
              onClick={() => setShowFPUModal(true)}
              title={isGerman ? 'FPE Information' : 'FPU Information'}
            >
              ?
            </button>
          </label>
        </div>
      </div>
      
      <FPUExplanationModal
        isOpen={showFPUModal}
        onClose={() => setShowFPUModal(false)}
        language={language}
      />
    </div>
  );
};